import Carousel from "./Carousel";
import SectionHdr from "./SectionHeader";

export default function TopRatedSection({ books = [], selectedBooks = [], itemLimit = 8, onView, cart, addCart }) {
    const manualBooks = selectedBooks.slice(0, itemLimit);
    let TOP_RATED = manualBooks.length
        ? manualBooks
        : books.filter(b => b.rating >= 4.8 || b.reviewCount > 50).slice(0, itemLimit);
    if (TOP_RATED.length === 0) TOP_RATED = [...books].reverse().slice(0, itemLimit);

    if (TOP_RATED.length === 0) return null;

    return (
        <section className="section" style={{
            background: "white",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderTop: "3px solid #C0392B"
        }}>
            <Carousel
                books={TOP_RATED}
                onView={onView}
                cart={cart}
                addCart={addCart}
                renderHeader={(dots) => <SectionHdr pill="TOP RATED" rightContent={dots} />}
            />
        </section>
    );
}
